// React
import React from "react";
// React
// CSS
import styles from "./TicketShower.module.css";
// CSS
// Components
import TicketCard from "./TicketCard/TicketCard";
import DataAndInputContainer from "./DataAndInputContainer/DataAndInputContainer";
import PendingManager from "../../../../../Components/PendingManager/PendingManager";
// Components
// Models
import { I_TicketItem } from "../../../../../Models/interfaces";
// Models
// Modules
import { BiArrowBack } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
// Modules

type TicketShowerProps = {
  data: I_TicketItem;
  userToken: string;
  ticketId: string;
  isPending: boolean;
  setTrigger: React.Dispatch<React.SetStateAction<boolean>>;
};

const TicketShower: React.FunctionComponent<TicketShowerProps> = ({
  data,
  ticketId,
  userToken,
  isPending,
  setTrigger,
}) => {
  const navigate = useNavigate();
  return (
    <>
      <PendingManager
        data={
          <div
            className={`${styles.ticketManagerContainer} flex flex-col items-end w-full`}
          >
            <div
              onClick={() => {
                navigate(-1);
              }}
              className="flex flex-row-reverse items-center justify-between mt-4 px-4 pt-1 pb-3 w-full"
            >
              <h1 className=" ">بازگشت</h1>
              <BiArrowBack className="text-2xl" />
            </div>
            <p className="mt-4 pr-4 font-bold text-right">{data?.title}</p>
            <p className="mt-1 pr-4 text-xs text-right">
              <span>{data?.subject}</span>
              <span>{data?.last_update_at}</span>
            </p>
            <p className="mt-2 pr-4 text-right text-xs">
              شماره تیکت : {data.id}
            </p>
            <p className="mt-4 pr-4 text-right">{data?.text}</p>
            <button
              style={{
                background: data?.status?.color ?? "",
              }}
              className="text-white w-full text-center py-2 font-bold mt-2"
            >
              {data?.status?.name ?? ""}
            </button>
            {/*  */}
            {/*  */}
            {/*  */}
            {/*  */}
            {/*  */}
            <div
              className={`${styles.ticketDataContainer} mt-4 flex flex-col items-center w-full mb-[10vh]`}
            >
              {data.ticket_answers.map((item) => (
                <TicketCard key={Math.random() * 1200000} data={item} />
              ))}
              <DataAndInputContainer
                ticketId={String(ticketId)}
                userToken={userToken}
                setTrigger={setTrigger}
              />
            </div>
          </div>
        }
        isPending={isPending}
      />
    </>
  );
};

export default TicketShower;
